/**
 * Rôles de l'utilisateur connecté, en minuscules (rôle principal et rôles
 * secondaires). Sert à MONTRER ou CACHER un bouton ; l'autorité reste le
 * microservice, qui refuse de toute façon un geste hors droits.
 */
export interface UtilisateurAvecRoles {
  role?: string | null;
  roles?: (string | null | undefined)[] | null;
}

export function rolesDe(user: UtilisateurAvecRoles | null | undefined): string[] {
  if (!user) return [];
  return [user.role, ...(user.roles ?? [])]
    .filter((r): r is string => typeof r === "string" && r.length > 0)
    .map((r) => r.toLowerCase());
}

export function aUnDesRoles(
  user: UtilisateurAvecRoles | null | undefined,
  roles: ReadonlySet<string> | readonly string[],
): boolean {
  const ensemble = roles instanceof Set ? roles : new Set(roles as readonly string[]);
  return rolesDe(user).some((r) => ensemble.has(r));
}

/** Administrateurs diocésains : mêmes droits que le curé sur l'espace paroisse. */
export const ADMINS = ["admin", "super_admin", "edaci_admin"] as const;

/**
 * Clé du rôle à AFFICHER (libellé `auth.roles.<clé>.label`). Le BFF donne
 * aux administrateurs diocésains le rôle d'écran « cure » pour leurs DROITS
 * (accès à tout) ; l'écran ne doit pas pour autant les dire « Curé »
 * (diagnostic du 19/10/2026) : ils s'affichent « Administrateur ». Un compte
 * qui porte vraiment le rôle de curé reste « Curé ».
 */
export function cleRoleAffiche(role: string | null | undefined, roles?: (string | null | undefined)[] | null): string {
  const principal = String(role ?? "").toLowerCase();
  const tous = (roles ?? []).filter((r): r is string => typeof r === "string").map((r) => r.toLowerCase());
  if (principal === "cure" && !tous.includes("cure") && tous.some((r) => (ADMINS as readonly string[]).includes(r))) {
    return "admin";
  }
  return principal;
}
